import { Component } from '@angular/core';

@Component({
  selector: 'app-item-padding',
  templateUrl: './item-padding.component.html',
  styleUrls: ['./item-padding.component.scss'],
})
export class ItemPaddingComponent {

  constructor() { }


}
